import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | timeout

  useEffect(() => {
    if (!sessionId) { setState("timeout"); return; }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/subscription/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
      } catch (e) { /* keep polling */ }
      if (tries >= 8) { setState("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="flex items-center justify-center py-24" data-testid="payment-success-page">
      <div className="text-center max-w-md">
        {state === "checking" && (
          <>
            <Loader2 className="w-10 h-10 animate-spin text-brand mx-auto mb-4" />
            <h1 className="text-xl font-medium">お支払いを確認しています...</h1>
            <p className="text-sm text-muted-foreground mt-2">画面を閉じずにお待ちください。</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto mb-4" data-testid="payment-success-icon" />
            <h1 className="text-2xl font-medium">ご登録ありがとうございます！</h1>
            <p className="text-sm text-muted-foreground mt-2">プランが有効になりました。引き続きすべての機能をご利用いただけます。</p>
            <Button onClick={() => navigate("/dashboard")} className="mt-6 bg-brand hover:bg-brand-hover text-white" data-testid="payment-success-dashboard">ダッシュボードへ</Button>
          </>
        )}
        {state === "timeout" && (
          <>
            <XCircle className="w-14 h-14 text-amber-500 mx-auto mb-4" />
            <h1 className="text-xl font-medium">確認に時間がかかっています</h1>
            <p className="text-sm text-muted-foreground mt-2">反映まで少し時間がかかる場合があります。お支払いページで状況をご確認ください。</p>
            <Button onClick={() => navigate("/settings/billing")} className="mt-6 bg-brand hover:bg-brand-hover text-white" data-testid="payment-timeout-billing">お支払いページへ</Button>
          </>
        )}
      </div>
    </div>
  );
}
